<div class="p-5">
  <div class="d-flex justify-content-end pr-5 pb-5">
    <button mat-button mat-dialog-close color="primary">Close</button>
  </div>

  <div class="pb-5" style="max-height: calc(85vh - 80px); overflow-y: auto">
    <ng-container *ngFor="let card of data.medications">
      <kt-med-review-card [data]="card" [statusKey]="card.classification" [isPv]="true">
      </kt-med-review-card>
    </ng-container>
  </div>
</div>
